import React, { Fragment } from 'react';
import AddBoxIcon from '@material-ui/icons/AddBox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

const ReactTableActionsMedics = ({ data, Callback }) => {

  return (<Fragment>
    <td role="cell">
      <Tooltip title="Agregar">
        <IconButton onClick={() => {
          //console.log(data.data.original);
          Callback(data.data.original);
        }}>
          <AddBoxIcon />
        </IconButton>
      </Tooltip>
    </td>
  </Fragment>)
}

export default ReactTableActionsMedics;